import type { CheckoutRequest, CheckoutResponse } from "@/app/billing/types";
import { getCoordinatorApi } from "@/lib/api";

export const createCheckout = async ({
  data,
  organizationId,
}: {
  data: CheckoutRequest;
  organizationId: string;
}): Promise<CheckoutResponse> => {
  const api = getCoordinatorApi({ organizationId });
  const { data: response } = await api.post<CheckoutResponse>(
    "/billing/checkout",
    data
  );

  return response;
};
